import { COLOR_PALETTE, mediaQuery } from 'constants/ui';

import { INSPECTOR_PANE_WIDTH } from './DocumentInspector.constants';

export const documentHeaderStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  padding: '16px 18px 14px',
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
  flexShrink: 0,
};

export const documentHeaderNameRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
};

export const documentHeaderActionsStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '4px 8px 0',
};

export const collapseButtonStyles = {
  marginLeft: 'auto',
  flexShrink: 0,
};

export const documentIconTileStyles = {
  width: '30px',
  height: '30px',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  backgroundColor: COLOR_PALETTE.RED[1],
  color: COLOR_PALETTE.RED[8],
};

export const inspectorPaneStyles = {
  width: `${INSPECTOR_PANE_WIDTH}px`,
  minWidth: `${INSPECTOR_PANE_WIDTH}px`,
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflowY: 'auto',
  borderLeft: ({ palette }) => `1px solid ${palette.divider}`,
  backgroundColor: ({ palette }) => palette.background.paper,
  // On mobile the wrapper stacks columns so the inspector should be full-width.
  [mediaQuery.mobile]: {
    width: '100%',
    minWidth: 0,
    borderLeft: 'none',
    borderTop: ({ palette }) => `1px solid ${palette.divider}`,
  },
};

export const inspectorEmptyStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  padding: '24px 16px',
  gap: '8px',
  color: 'text.secondary',
};

export const tabContentStyles = {
  flex: 1,
  overflowY: 'auto',
  padding: '16px',
};

export const detailRowStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: '8px 0',
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
  '&:last-child': {
    borderBottom: 'none',
  },
};

export const tabsRowStyles = {
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
  flexShrink: 0,
};

export const detailNameValueStyles = {
  maxWidth: '60%',
  textAlign: 'right',
  wordBreak: 'break-word',
};

/**
 * Indents the header subtitle to align with the filename text,
 * clearing the 30px icon/badge tile + 10px gap.
 */
export const documentHeaderSubtitleStyles = {
  marginLeft: '40px',
};

export const statusRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
  marginLeft: '40px',
};

export const statusChipDotStyles = {
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  backgroundColor: 'currentColor',
  flexShrink: 0,
};

export const countRowStyles = {
  display: 'flex',
  alignItems: 'baseline',
  gap: '8px',
  flexWrap: 'wrap',
  marginLeft: '40px',
};

const helperBannerBaseStyles = {
  display: 'flex',
  gap: '8px',
  alignItems: 'flex-start',
  marginLeft: '40px',
  borderRadius: '6px',
  padding: '8px 10px',
};

// Mirrors the confidence-badge palette pairing (documentsConfidence.styles.js):
// light mode = palest tint fill + deep text; dark mode = low-alpha soft fill +
// the bright main text so the banner never leaks a near-white slab on dark.
export const helperBannerWarningStyles = {
  ...helperBannerBaseStyles,
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.warning.soft : palette.warning.extraSoft,
  color: ({ palette }) =>
    palette.mode === 'dark' ? palette.warning.main : COLOR_PALETTE.ORANGE[9],
};

export const helperBannerErrorStyles = {
  ...helperBannerBaseStyles,
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.error.soft : palette.error.extraSoft,
  color: ({ palette }) => (palette.mode === 'dark' ? palette.error.main : COLOR_PALETTE.RED[8]),
};
